import OtherConfigCommonFilter from './OtherConfigCommonFilter'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { getBkngPrintOpt, getHeaderColumnDefs, getOtherCargoCol8Defs, requiredLabelTxt } from '../../BrnchMasterConstant'
import DropDownOA from '../../../../../common/dropDownOA'
import { Item } from '../../../../../common/snippets'
import { clickElement, findObjctByValueFromArrayOfObject, navigation3, removeDuplicatesFromArray } from '../../../../../common/helper'
import Lineinput from '../../../../../common/lineinput'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import PrintIcon from '@mui/icons-material/Print';
import SaveIcon from '@mui/icons-material/Save';
import { useEffect, useState } from 'react'
import DropDownMultiSelect from '../../../../../common/dropDownMultiSelect'
import OtherConfigCommonBottom from './OtherConfigCommonBottom'
import MultiSelectDropDownV2 from '../../../../../common/MultiSelectDropDownV2'
import { callAddFontRobotoBold } from '../../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { useDispatch } from 'react-redux'
import { STA_COMPANY_ID } from '../../../../../../helper/companyIdhardcode'
import { useTranslation } from '../../../../../../i18n/I18nProvider'

const OtherConfigPrint = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const bkngPrintOpt = getBkngPrintOpt(translations)
    const headerColumnDefs = getHeaderColumnDefs(translations)
    const otherCargoCol8Defs = getOtherCargoCol8Defs(translations)

  const {
    tabInfo,
    selectedOtherWayBill, setSelectedOtherWayBillFormat, waybillFormats, selectedDeliveryWayBill, setSelectedDeliveryWaybill,
    bkngPrnitCopy, setBkngPrnitCopy, delPrnitCopy, setDelPrnitCopy
  } = props
  const { resetFlag, setResetFlag, resetAllValueBrnhMaster, getBranchCargoData,
    brnhOtherCargoValue, setBrnchOtherCargoValue, onSave, confModal, setConfModal, isDisableBtn, setIsDisableBtn,
    handleBack, showBottom, setShowBottom, headerData, getPdfData, loginData } = tabInfo
  const [deliveryWaybillFormat, setDeliveryWaybillFormat] = useState([])
  const [searchResult, setSearchResult] = useState(false)
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    const fetchTableData = async () => {
      let data = await getPdfData()
      const formattedData = data.map((item, index) => {
        const bkngPrintCopyArr = [];
        if (item?.IsBookingCustomerCopy === 1) {
          bkngPrintCopyArr.push(bum.customerCopy || 'Customer Copy');
        }
        if (item?.IsBookingBranchCopy === 1) {
          bkngPrintCopyArr.push(bum.branchCopy || 'Branch Copy');
        }
        if (item?.IsBookingDriverCopy === 1) {
          bkngPrintCopyArr.push(bum.driverCopy || 'Driver Copy');
        }

        const bkngPrintCopyTemp = bkngPrintCopyArr.join(', ');
        const delPrintCopyArr = [];
        if (item?.IsDeliveryCustomerCopy === 1) {
          delPrintCopyArr.push(bum.customerCopy || 'Customer Copy');
        }
        if (item?.IsDeliveryBranchCopy === 1) {
          delPrintCopyArr.push(bum.branchCopy || 'Branch Copy');
        }
        if (item?.IsDeliveryDriverCopy === 1) {
          delPrintCopyArr.push(bum.driverCopy || 'Driver Copy');
        }
        const delPrintCopyTemp = delPrintCopyArr.join(', ');
        return {
          ...item,
          SN: index + 1,
          bkngPrintOptions: createCommaSeparatedString(
            waybillFormats?.filter((val) => val?.FormatID === item?.CargoStandardTicketFormatID),
            'FormatName'
          ),
          bkngPrintCopy: bkngPrintCopyTemp,  // Assign the built comma-separated string
          DelPrintOptions: createCommaSeparatedString(
            waybillFormats?.filter((val) => val?.FormatID === item?.DeliveryPrintFormatID),
            'FormatName'
          ),
          delPrintCopy: delPrintCopyTemp
        };
      });
      setTableData(formattedData);
    };

    fetchTableData();
  }, [])
  useEffect(() => {
    if (waybillFormats?.length > 0) {
      let filterData = waybillFormats?.filter((item) => item.FormatID !== 4)
      setDeliveryWaybillFormat(filterData)
      setSelectedDeliveryWaybill(filterData[0])
    }
  }, [waybillFormats])
  const [disableBkng, setDisableBkng] = useState(false)
  const [disableDelvry, setDisableDelvry] = useState(false)

  useEffect(() => {
    if ([2, 3, 4, 5, 7].includes(brnhOtherCargoValue?.CargoStandardTicketFormatID)) {
      setDisableBkng(true);
    } else {
      setDisableBkng(false)
    }
  }, [brnhOtherCargoValue?.CargoStandardTicketFormatID]);

  useEffect(() => {
    if ([2, 3, 4, 5, 6].includes(brnhOtherCargoValue?.DeliveryPrintFormatID)) {
      setDisableDelvry(true);
    } else {
      setDisableDelvry(false);
    }
  }, [brnhOtherCargoValue?.DeliveryPrintFormatID]);
  const createCommaSeparatedString = (array, property) => {
    return array
      ?.map((item) => item?.[property])
      .filter(Boolean) // This will remove any undefined or null values
      .join(', ');
  };
  const printClick = async (isSave = false) => {
    let pdfData = await getPdfData()

    const newData = pdfData.map((item, index) => {
      const bkngPrintCopyArr = [];
      if (item?.IsBookingCustomerCopy === 1) {
        bkngPrintCopyArr.push(bum.customerCopy || 'Customer Copy');
      }
      if (item?.IsBookingBranchCopy === 1) {
        bkngPrintCopyArr.push(bum.branchCopy || 'Branch Copy');
      }
      if (item?.IsBookingDriverCopy === 1) {
        bkngPrintCopyArr.push(bum.driverCopy || 'Driver Copy');
      }

      const bkngPrintCopyTemp = bkngPrintCopyArr.join(', ');
      const delPrintCopyArr = [];
      if (item?.IsDeliveryCustomerCopy === 1) {
        delPrintCopyArr.push(bum.customerCopy || 'Customer Copy');
      }
      if (item?.IsDeliveryBranchCopy === 1) {
        delPrintCopyArr.push(bum.branchCopy || 'Branch Copy');
      }
      if (item?.IsDeliveryDriverCopy === 1) {
        delPrintCopyArr.push(bum.driverCopy || 'Driver Copy');
      }
      const delPrintCopyTemp = delPrintCopyArr.join(', ');
      return {
        ...item,
        SN: index + 1,
        bkngPrintOptions: createCommaSeparatedString(
          waybillFormats?.filter((val) => val?.FormatID === item?.CargoStandardTicketFormatID),
          'FormatName'
        ),
        bkngPrintCopy: bkngPrintCopyTemp,  // Assign the built comma-separated string
        DelPrintOptions: createCommaSeparatedString(
          waybillFormats?.filter((val) => val?.FormatID === item?.DeliveryPrintFormatID),
          'FormatName'
        ),
        delPrintCopy: delPrintCopyTemp
      };
    });
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = headerColumnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfCols = otherCargoCol8Defs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }
    doc.setProperties({
      title: `Print Config.pdf`,
      subject: 'Cargo Other Config',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Cargo Other Config',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: headerData,
      columnStyles: {
        0: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 16,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },

    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfCols,
      body: newData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 37, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo Other Config | Print Config.', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Print: Cargo Other Config | Print Config.`, data.settings.margin.left, 140)
        doc.text(`Branch: ${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 140, "right")
        doc.text(`Date & Time: ${moment(new Date()).format('DD-MMM-YYYY, ddd, HH:mm')} `, data.settings.margin.left, 160)
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      }
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      const pdfData = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfData);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'Cargo Config-Print Config.pdf';
      link.click();
    } else {
      // Trigger download
      const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // Open the PDF in a new tab
      window.open(pdfUrl);
    }
  }
  const handleBrnhCargoValue = (value, field, prevValue) => {
    if (value != prevValue) {
      if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
        setConfModal((prev) => ({
          ...prev,
          branchOtherConfig: true
        }))
      }
      setBrnchOtherCargoValue((prev) => ({
        ...prev, [field]: value
      }))
    }
  }
  const handleBkngPrint = (val) => {
    let value = removeDuplicatesFromArray(val, 'id')
    let idArray = value?.map(item => item.id)
    setBrnchOtherCargoValue((prev) => ({
      ...prev,
      IsBookingCustomerCopy: idArray?.includes(1) ? 1 : 0,
      IsBookingBranchCopy: idArray?.includes(2) ? 1 : 0,
      IsBookingDriverCopy: idArray?.includes(3) ? 1 : 0,
    }))
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setBkngPrnitCopy(value)
  }
  const handleDelvryPrint = (val) => {
    let value = removeDuplicatesFromArray(val, 'id')
    let idArray = value?.map(item => item.id)
    setBrnchOtherCargoValue((prev) => ({
      ...prev,
      IsDeliveryCustomerCopy: idArray?.includes(1) ? 1 : 0,
      IsDeliveryBranchCopy: idArray?.includes(2) ? 1 : 0,
      IsDeliveryDriverCopy: idArray?.includes(3) ? 1 : 0,
    }))
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setDelPrnitCopy(value)
  }
  const handleBkngPrintOpt = (val) => {
    setSelectedOtherWayBillFormat(val)
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setBrnchOtherCargoValue((prev) => ({
      ...prev,
      CargoStandardTicketFormatID: val?.FormatID
    }))
    if ([1, 4, 7].includes(val?.FormatID)) {
      handleBkngPrint(bkngPrintOpt)
      if (val?.FormatID === 4) {
        setDisableBkng(true)
      } else {
        setDisableBkng(false)
      }
    } else if (val?.FormatID === 2) {
      handleBkngPrint([])
      setDisableBkng(true)
    } else if (val.FormatID === 3) {
      let filterData = bkngPrintOpt?.filter((item) => item?.id !== 3)
      handleBkngPrint(filterData)
      setDisableBkng(true)
    } else if (val.FormatID === 5) {
      handleBkngPrint([])
      setDisableBkng(true)
    }
  }
  const handleDelvryPrintOpt = (val) => {
    setSelectedDeliveryWaybill(val)
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setBrnchOtherCargoValue((prev) => ({
      ...prev,
      DeliveryPrintFormatID: val?.FormatID,
    }))
    if (val?.FormatID === 1 || val?.FormatID === 4) {
      handleDelvryPrint(bkngPrintOpt)
      if (val?.FormatID === 4) {
        setDisableDelvry(true)
      } else {
        setDisableDelvry(false)
      }
    } else if (val?.FormatID === 2 || val?.FormatID === 6) {
      handleDelvryPrint([])
      setDisableDelvry(true)
    } else if (val.FormatID === 3) {
      let filterData = bkngPrintOpt?.filter((item) => item?.id !== 3)
      handleDelvryPrint(filterData)
      setDisableDelvry(true)
    } else if (val.FormatID === 5) {
      handleDelvryPrint([])
      setDisableDelvry(true)
    }
  }
  const bookingPrintProps = () => {
    return {
      width: "100%",
      id: 'bkngPrint',
      name: "bkngPrint",
      label: bum.bookingPrintCopy || "Booking Print Copy",
      isCompulsory: false,
      options: bkngPrintOpt || [],
      preSelectedValues: bkngPrnitCopy || [],
      searchPlaceholder: bum.searchByBookingPrintCopy || "Search by Booking Print Copy",
      disabled: brnhOtherCargoValue?.CargoHasBilltyLaserPrint === 0 || disableBkng,
      isObject: true,
      primaryKey: 'id',
      labelKey: 'name',
      singleSelect: false,
      selectAllOption: false,
      defaultAllSelected: false,
      direction: 'up',
      listHeight: '130px'
    }
  }
  const deliveryPrintProps = () => {
    return {
      width: "100%",
      id: 'delvryPrint',
      name: "delvryPrint",
      label: bum.deliveryPrintCopy || "Delivery Print Copy",
      isCompulsory: false,
      options: bkngPrintOpt || [],
      preSelectedValues: delPrnitCopy || [],
      searchPlaceholder: bum.searchByDeliveryPrintCopy || "Search by Delivery Print Copy",
      disabled: brnhOtherCargoValue?.CargoHasBilltyLaserPrint === 0 || disableDelvry,
      isObject: true,
      primaryKey: 'id',
      labelKey: 'name',
      singleSelect: false,
      selectAllOption: false,
      defaultAllSelected: false,
      direction: 'up',
      listHeight: '130px'
      // portal:true
    }
  }
  
  const getBookingPrintFormats = (list=[])=>{
    if(loginData.intCompanyID===STA_COMPANY_ID){
      return list
    }else{
      return list.filter((a)=>a.FormatID!==6)
    }
  }
  const getDeliveryFromats = (list)=>{
    if(loginData.intCompanyID===STA_COMPANY_ID){
      return list
    }else{
      return list.filter((a)=>a.FormatID!==7)
    }
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          <>
            <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchCode}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.CityName}
            </TableCell>

            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.StateName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.bkngPrintOptions}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {item.bkngPrintCopy}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.sgsDelPrintOptionst}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.delPrintCopy}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    !searchResult ?
      <>
        <OtherConfigCommonFilter
          resetAllValueBrnhMaster={() => {
            resetAllValueBrnhMaster();
            setResetFlag(!resetFlag)
          }}
          nextId='bkng-print-opt' getData={getBranchCargoData} setShowBottom={setShowBottom} />
        <Divider />
        {showBottom && <> <Grid container sx={{ padding: '6px 8px', display: 'flex', flexWrap: 'nowrap' }}>
          <Grid item md={0.3}>
            <Item sx={{ paddingY: '5px' }}>
              <FormControlLabel
                value="end"
                control={<Checkbox checked={brnhOtherCargoValue.CargoHasBilltyLaserPrint === 1} id={`BrnhCargConfigCheckBox`} />}
                onKeyDown={(e) => {
                  navigation3(e, ``, ``, () => { })
                }}
                label=""
                onChange={(event) => {
                  handleBrnhCargoValue(event.target.checked ? 1 : 0, 'CargoHasBilltyLaserPrint', brnhOtherCargoValue.CargoHasBilltyLaserPrint)
                }}
                labelPlacement="end"
              />
            </Item>
          </Grid>
          <Grid item md={3}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <DropDownOA
                label={bum.bookingPrintOptions || 'Booking Print Options'}
                data={getBookingPrintFormats(waybillFormats) || []}
                defaultvalue={selectedOtherWayBill?.FormatName}
                value={selectedOtherWayBill?.FormatName}
                onSelect={(waybill) => {
                  handleBkngPrintOpt(waybill)
                }}
                onReset={() => setSelectedOtherWayBillFormat('')}
                disabled={brnhOtherCargoValue?.CargoHasBilltyLaserPrint === 0}
                id={'bkng-print-opt'}
                idKey={`FormatID`}
                dataKey={'FormatName'}
                nextId={'bkng-print-copy'}
                prevId={''}
                portal={true}
              />
            </Item>
          </Grid>
          <Grid item md={3}>
            <Item >
              <MultiSelectDropDownV2
                {...bookingPrintProps()}
                onSelect={(val) => { handleBkngPrint(val) }}
                onRemove={(val) => { handleBkngPrint(val) }}
              />
            </Item>
          </Grid>
          <Grid item md={3}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <DropDownOA
                label={bum.deliveryPrintOptions || 'Delivery Print Options'}
                data={ getDeliveryFromats(deliveryWaybillFormat)}
                defaultvalue={selectedDeliveryWayBill?.FormatName}
                value={selectedDeliveryWayBill?.FormatName}
                onSelect={(waybill) => {
                  handleDelvryPrintOpt(waybill)
                }}
                onReset={() => setSelectedDeliveryWaybill('')}
                disabled={brnhOtherCargoValue?.CargoHasBilltyLaserPrint === 0}
                id={'del-print-opt'}
                idKey={`FormatID`}
                dataKey={'FormatName'}
                nextId={'del-print-copy'}
                prevId={'bkng-print-copy'}
                portal={true}
              />
            </Item>
          </Grid>
          <Grid item md={3}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <MultiSelectDropDownV2
                {...deliveryPrintProps()}
                onSelect={(val) => handleDelvryPrint(val)}
                onRemove={(val) => { handleDelvryPrint(val) }}
              />
            </Item>
          </Grid>
        </Grid>
          <Divider />
          <OtherConfigCommonBottom onSave={onSave} handleBack={handleBack} printClick={printClick} setSearchResult={setSearchResult} fileName={'printConfig'} />
        </>}
        <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
          {/* ---------------Table For Excel--------------- */}
          <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              {/* -------TableHeader--------- */}
              <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                <TableCell className="reportTD" colSpan={4}>
                  {bum.reportForPrintConfig || 'Report For: Print Config'}
                </TableCell>
                <TableCell className="reportTD" colSpan={4}>
                  {bum.companyNameMavenTechServicesPvtLtd || 'Company Name : _Maven Tech Services Pvt. Ltd.'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {headerColumnDefs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={2}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
              {headerData?.map((item, i) => (
                <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.CompanyName}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.State}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.City}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.Branch}</span>
                  </TableCell>
                </TableRow>))}
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ fontSize: '16px', verticalAlign: 'top' }}>
                {otherCargoCol8Defs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={1}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>{cs.noResultsFound || 'No results found. Please refine your search parameters and search again.'}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContentForExcel item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </> :
      <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
        <object
          id="printConfigOutput"
          type="application/pdf"
          width="100%"
          height="200"
          title={bum.mtlplCargoSystemCargoConfigPrintConfig || 'MTLPL -Cargo System - Cargo Config - Print Config'}
          aria-label={bum.mtlplCargoSystemCargoConfigPrintConfig2 || 'MTLPL -Cargo System - Cargo Config- Print Config'}
        ></object>
      </Box>
  )
}

export default OtherConfigPrint
